import { render, staticRenderFns } from "./IconSelectorSolid.vue?vue&type=template&id=8d88f22a"
import script from "./IconSelectorSolid.vue?vue&type=script&lang=js"
export * from "./IconSelectorSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports